import { AttributeCfg } from '../interface';
import Attribute from './base';

export default class Opacity extends Attribute {
  constructor(cfg: AttributeCfg) {
    super(cfg);
    this.type = 'opacity';
    this.names = ['opacity'];
  }
}
